export default __webpack_public_path__ + "static/media/soy-sensible-soy-social.3d8a00ab.jpg";